// extracted by mini-css-extract-plugin
export default {"styles":"WHFooter_styles__NvM5b"};